import { ProteinBalanceResponse } from "@/clients/models/ProteinBalanceResponse";
import { BalanceService } from "@/clients/services/BalanceService";
import { QueryKeys } from "@/constants/query-keys";
import { QueryStaleTime } from "@/constants/query-stale-time";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetProteinBalance = () => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: [QueryKeys.BALANCE_PROTEIN],
    staleTime: QueryStaleTime.SHORT,
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const response = await BalanceService.getProteinBalanceApiV1BalanceProteinGet(user.id);

      return response.data;
    },
  });

  return {
    proteinBalance: data as ProteinBalanceResponse | undefined,
    isLoading,
    isError,
    error,
    refetch,
  };
};
